(function () {
  "use strict";

  var reduced = matchMedia("(prefers-reduced-motion: reduce)").matches;
  var fineHover = matchMedia("(hover: hover) and (pointer: fine)").matches;

  var $  = function (sel, scope) { return (scope || document).querySelector(sel); };
  var $$ = function (sel, scope) { return Array.prototype.slice.call((scope || document).querySelectorAll(sel)); };

  function safe(fn, name) {
    try { fn(); } catch (e) { console.warn("[" + name + "] failed:", e); }
  }

  /* ---------------- Splash ---------------- */
  function initSplash() {
    var splash = $("[data-splash]");
    if (!splash) return;
    var hide = function () { splash.classList.add("is-out"); };
    if (document.readyState === "complete") setTimeout(hide, 500);
    else window.addEventListener("load", function () { setTimeout(hide, 350); });
    setTimeout(hide, 2600);
  }

  /* ---------------- Nav ---------------- */
  function initNav() {
    var nav = $("[data-nav]");
    var toggle = $("[data-nav-toggle]");
    var links = $("[data-nav-links]");
    if (!nav) return;

    var onScroll = function () {
      if (window.scrollY > 40) nav.classList.add("is-scrolled");
      else nav.classList.remove("is-scrolled");
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });

    if (toggle && links) {
      toggle.addEventListener("click", function () {
        var open = toggle.getAttribute("aria-expanded") === "true";
        toggle.setAttribute("aria-expanded", String(!open));
        toggle.setAttribute("aria-label", open ? "Abrir menú" : "Cerrar menú");
        links.classList.toggle("is-open", !open);
        document.body.style.overflow = open ? "" : "hidden";
      });
      $$("a", links).forEach(function (a) {
        a.addEventListener("click", function () {
          toggle.setAttribute("aria-expanded", "false");
          links.classList.remove("is-open");
          document.body.style.overflow = "";
        });
      });
    }
  }

  /* ---------------- Smooth anchor scroll (native) ---------------- */
  function initSmoothScroll() {
    document.addEventListener("click", function (e) {
      var a = e.target.closest && e.target.closest('a[href^="#"]');
      if (!a) return;
      var id = a.getAttribute("href");
      if (!id || id === "#" || id.length < 2) return;
      var el;
      try { el = document.querySelector(id); } catch (_) { return; }
      if (!el) return;
      e.preventDefault();
      var navOffset = 84;
      window.scrollTo({
        top: el.getBoundingClientRect().top + window.scrollY - navOffset,
        behavior: reduced ? "auto" : "smooth"
      });
    });
  }

  /* ---------------- Reveal on scroll ---------------- */
  function initReveals() {
    var items = $$(".reveal");
    if (!items.length) return;

    if (!("IntersectionObserver" in window)) {
      items.forEach(function (el) { el.classList.add("is-visible"); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-visible");
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.02, rootMargin: "0px 0px -2% 0px" });

    items.forEach(function (el) { io.observe(el); });

    setTimeout(function () {
      $$(".reveal:not(.is-visible)").forEach(function (el) {
        if (el.getBoundingClientRect().top < window.innerHeight) el.classList.add("is-visible");
      });
    }, 6000);
  }

  /* ---------------- Mesh gradient follows cursor slightly ---------------- */
  function initHeroMesh() {
    var mesh = $("[data-mesh]");
    if (!mesh || !fineHover || reduced) return;
    var hero = $(".hero");
    var raf = null;
    hero.addEventListener("mousemove", function (e) {
      var rect = hero.getBoundingClientRect();
      var x = ((e.clientX - rect.left) / rect.width - 0.5) * 14;
      var y = ((e.clientY - rect.top) / rect.height - 0.5) * 14;
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        mesh.style.transform = "translate(" + x + "px," + y + "px)";
      });
    });
    hero.addEventListener("mouseleave", function () {
      mesh.style.transform = "";
    });
  }

  /* ---------------- Tilt 3D on cards ---------------- */
  function initTilt() {
    if (!fineHover) return;
    $$("[data-tilt]").forEach(function (card) {
      if (card.dataset.tiltBound) return;
      card.dataset.tiltBound = "1";
      var raf = null;
      card.addEventListener("mousemove", function (e) {
        var rect = card.getBoundingClientRect();
        var px = (e.clientX - rect.left) / rect.width - 0.5;
        var py = (e.clientY - rect.top) / rect.height - 0.5;
        if (raf) cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          card.style.transform = "perspective(900px) rotateX(" + (-py * 7) + "deg) rotateY(" + (px * 7) + "deg) translateY(-4px)";
        });
      });
      card.addEventListener("mouseout", function (e) {
        if (card.contains(e.relatedTarget)) return;
        card.style.transform = "";
      });
    });
  }

  /* ---------------- Magnetic buttons ---------------- */
  function initMagnetic() {
    if (!fineHover) return;
    $$("[data-magnetic]").forEach(function (btn) {
      if (btn.dataset.magneticBound) return;
      btn.dataset.magneticBound = "1";
      var raf = null;
      btn.addEventListener("mousemove", function (e) {
        var rect = btn.getBoundingClientRect();
        var x = (e.clientX - rect.left - rect.width / 2) * 0.25;
        var y = (e.clientY - rect.top - rect.height / 2) * 0.35;
        if (raf) cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          btn.style.transform = "translate(" + x + "px," + y + "px)";
        });
      });
      btn.addEventListener("mouseout", function (e) {
        if (btn.contains(e.relatedTarget)) return;
        btn.style.transform = "";
      });
    });
  }

  /* ---------------- Count-up stats ---------------- */
  function initCountUp() {
    var nums = $$("[data-count-to]");
    if (!nums.length || !("IntersectionObserver" in window)) {
      nums.forEach(function (el) { el.textContent = el.getAttribute("data-count-to"); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        io.unobserve(entry.target);
        var el = entry.target;
        var target = parseInt(el.getAttribute("data-count-to"), 10) || 0;
        var duration = 1400;
        var start = null;
        function step(ts) {
          if (start === null) start = ts;
          var progress = Math.min((ts - start) / duration, 1);
          var eased = 1 - Math.pow(1 - progress, 3);
          el.textContent = String(Math.floor(eased * target));
          if (progress < 1) requestAnimationFrame(step);
          else el.textContent = String(target);
        }
        requestAnimationFrame(step);
      });
    }, { threshold: 0.05 });
    nums.forEach(function (el) { io.observe(el); });

    setTimeout(function () {
      $$("[data-count-to]").forEach(function (el) {
        if (el.getBoundingClientRect().top < window.innerHeight && el.textContent === "0") {
          el.textContent = el.getAttribute("data-count-to");
        }
      });
    }, 6000);
  }

  /* ---------------- Product option / variant picker (product page) ---------------- */
  function initProductOptions() {
    var section = $("[data-product-section]");
    if (!section) return;
    var jsonEl = $("[data-product-json]", section);
    if (!jsonEl) return;

    var variants;
    try { variants = JSON.parse(jsonEl.textContent); } catch (e) { return; }

    var form = $(".product-form", section);
    var variantInput = form && $("[data-variant-input]", form);
    var priceEl = $("[data-product-price]", section);
    var addBtn = $("[data-add-submit]", section);
    var mainImage = $("[data-product-main-image]", section);

    var selected = [];
    $$(".product-option-values", section).forEach(function (group, i) {
      var selectedPill = $(".option-pill.is-selected", group);
      selected[i] = selectedPill ? selectedPill.getAttribute("data-option-value") : null;
    });

    function findVariant() {
      return variants.find(function (v) {
        return v.options.every(function (opt, i) { return selected[i] == null || opt === selected[i]; });
      });
    }

    function money(cents) {
      return "$" + (cents / 100).toFixed(2);
    }

    function applyVariant(variant) {
      if (!variant) return;
      if (variantInput) variantInput.value = variant.id;
      if (priceEl) {
        var compareHtml = "";
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareHtml = '<s class="product-price-compare">' + money(variant.compare_at_price) + "</s>";
        }
        priceEl.innerHTML = money(variant.price) + compareHtml;
      }
      if (addBtn) {
        addBtn.disabled = !variant.available;
        var label = $("span", addBtn);
        if (label) label.textContent = variant.available ? "Agregar al carrito" : "Agotado";
      }
      if (mainImage && variant.featured_image && variant.featured_image.src) {
        mainImage.src = variant.featured_image.src;
      }
    }

    $$(".product-option-values", section).forEach(function (group, groupIndex) {
      $$(".option-pill", group).forEach(function (pill) {
        pill.addEventListener("click", function () {
          $$(".option-pill", group).forEach(function (p) { p.classList.remove("is-selected"); });
          pill.classList.add("is-selected");
          selected[groupIndex] = pill.getAttribute("data-option-value");
          applyVariant(findVariant());
        });
      });
    });

    $$("[data-qty-decrease]", section).forEach(function (btn) {
      btn.addEventListener("click", function () {
        var input = btn.parentElement.querySelector("input");
        input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
      });
    });
    $$("[data-qty-increase]", section).forEach(function (btn) {
      btn.addEventListener("click", function () {
        var input = btn.parentElement.querySelector("input");
        input.value = (parseInt(input.value, 10) || 1) + 1;
      });
    });

    if (form) {
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        var id = variantInput ? variantInput.value : null;
        var qtyInput = $("#ProductQty", form);
        var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
        if (!id) return;
        cartAdd(id, qty).then(function () {
          openCartDrawer();
        });
      });
    }
  }

  /* ---------------- Card-level variant picker (Individual / Six pack, etc.) ---------------- */
  function initCardVariantPickers() {
    $$("[data-product-card]").forEach(function (card) {
      if (card.dataset.cardVariantBound) return;
      card.dataset.cardVariantBound = "1";

      var jsonEl = $("[data-product-json]", card);
      if (!jsonEl) return;
      var variants;
      try { variants = JSON.parse(jsonEl.textContent); } catch (e) { return; }

      var priceEl = $("[data-card-price]", card);
      var imageEl = $("[data-card-image]", card);
      var addBtn = $("[data-add-to-cart]", card);
      var group = $(".card-option-values", card);
      if (!group) return;

      function money(cents) {
        return "$" + (cents / 100).toFixed(2);
      }

      function applyVariant(value) {
        var variant = variants.find(function (v) { return v.options[0] === value; });
        if (!variant) return;
        if (priceEl) priceEl.textContent = money(variant.price);
        if (imageEl && variant.featured_image && variant.featured_image.src) {
          imageEl.src = variant.featured_image.src;
        }
        if (addBtn) {
          addBtn.setAttribute("data-variant-id", variant.id);
          addBtn.disabled = !variant.available;
          var label = $("span", addBtn);
          if (label) label.textContent = variant.available ? "Agregar al carrito" : "Agotado";
        }
      }

      $$(".option-pill", group).forEach(function (pill) {
        pill.addEventListener("click", function () {
          $$(".option-pill", group).forEach(function (p) { p.classList.remove("is-selected"); });
          pill.classList.add("is-selected");
          applyVariant(pill.getAttribute("data-option-value"));
        });
      });
    });
  }

  /* ---------------- Beer story accordions ---------------- */
  function initBeerToggles() {
    $$("[data-beer-toggle]").forEach(function (btn) {
      if (btn.dataset.bound) return;
      btn.dataset.bound = "1";
      btn.addEventListener("click", function () {
        var card = btn.closest(".beer-card");
        var story = card && $("[data-beer-story]", card);
        if (!story) return;
        var open = btn.getAttribute("aria-expanded") === "true";
        btn.setAttribute("aria-expanded", String(!open));
        story.classList.toggle("is-open", !open);
        var label = $("span", btn);
        if (label) label.textContent = open ? "Leer la historia" : "Ocultar historia";
      });
    });
  }

  /* ---------------- Cart (AJAX) ---------------- */
  function cartFetchJSON(url, opts) {
    return fetch(url, opts).then(function (res) { return res.json(); });
  }

  function cartAdd(variantId, quantity) {
    return cartFetchJSON("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: variantId, quantity: quantity || 1 })
    });
  }

  function cartChangeLine(line, quantity) {
    return cartFetchJSON("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ line: line, quantity: quantity })
    });
  }

  function cartUpdateNote(note) {
    return cartFetchJSON("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ note: note })
    });
  }

  function updateCartUI() {
    return cartFetchJSON("/cart.js").then(function (cart) {
      $$("[data-cart-count]").forEach(function (el) {
        el.textContent = cart.item_count;
        el.hidden = cart.item_count === 0;
      });
      $$("[data-cart-subtotal]").forEach(function (el) {
        el.textContent = "$" + (cart.total_price / 100).toFixed(2);
      });
      $$("[data-cart-foot]").forEach(function (el) {
        el.hidden = cart.item_count === 0;
      });
      renderCartItems(cart);
      return cart;
    });
  }

  function renderCartItems(cart) {
    var containers = $$("[data-cart-items]");
    if (!containers.length) return;

    var html;
    if (cart.item_count === 0) {
      html = '<div class="cart-empty"><p>Tu carrito está vacío.</p><a href="/collections/all" class="btn btn-outline">Ver cervezas</a></div>';
    } else {
      html = '<ul class="cart-line-items">' + cart.items.map(function (item, index) {
        var variantLine = item.variant_title && item.variant_title !== "Default Title"
          ? '<p class="cart-line-variant">' + item.variant_title + "</p>" : "";
        var img = item.image ? '<img src="' + item.image + '&width=160" alt="" width="80" height="80" loading="lazy">' : "";
        return (
          '<li class="cart-line-item" data-cart-line="' + (index + 1) + '">' +
            '<a href="' + item.url + '" class="cart-line-photo">' + img + "</a>" +
            '<div class="cart-line-info">' +
              '<a href="' + item.url + '" class="cart-line-name">' + item.product_title + "</a>" +
              variantLine +
              '<div class="cart-line-qty">' +
                '<button type="button" data-cart-qty-decrease aria-label="Reducir cantidad">−</button>' +
                '<input type="number" min="0" value="' + item.quantity + '" data-cart-qty-input aria-label="Cantidad" inputmode="numeric">' +
                '<button type="button" data-cart-qty-increase aria-label="Aumentar cantidad">+</button>' +
              "</div>" +
            "</div>" +
            '<div class="cart-line-price">$' + (item.final_line_price / 100).toFixed(2) +
              '<button type="button" class="cart-line-remove" data-cart-remove aria-label="Quitar">×</button>' +
            "</div>" +
          "</li>"
        );
      }).join("") + "</ul>";
    }
    containers.forEach(function (c) { c.innerHTML = html; });
    bindCartLineEvents();
  }

  function bindCartLineEvents() {
    $$("[data-cart-line]").forEach(function (line) {
      var index = parseInt(line.getAttribute("data-cart-line"), 10);
      var input = $("[data-cart-qty-input]", line);

      var dec = $("[data-cart-qty-decrease]", line);
      var inc = $("[data-cart-qty-increase]", line);
      var remove = $("[data-cart-remove]", line);

      if (dec) dec.addEventListener("click", function () {
        var qty = Math.max(0, (parseInt(input.value, 10) || 1) - 1);
        cartChangeLine(index, qty).then(updateCartUI);
      });
      if (inc) inc.addEventListener("click", function () {
        var qty = (parseInt(input.value, 10) || 1) + 1;
        cartChangeLine(index, qty).then(updateCartUI);
      });
      if (remove) remove.addEventListener("click", function () {
        cartChangeLine(index, 0).then(updateCartUI);
      });
      if (input) input.addEventListener("change", function () {
        var qty = Math.max(0, parseInt(input.value, 10) || 0);
        cartChangeLine(index, qty).then(updateCartUI);
      });
    });
  }

  function openCartDrawer() {
    var drawer = $("[data-cart-drawer]");
    if (!drawer) { window.location.href = "/cart"; return; }
    drawer.setAttribute("aria-hidden", "false");
    document.body.classList.add("cart-drawer-open");
    updateCartUI();
  }
  function closeCartDrawer() {
    var drawer = $("[data-cart-drawer]");
    if (!drawer) return;
    drawer.setAttribute("aria-hidden", "true");
    document.body.classList.remove("cart-drawer-open");
  }

  function initCart() {
    $$("[data-cart-icon]").forEach(function (icon) {
      icon.addEventListener("click", function (e) {
        var drawer = $("[data-cart-drawer]");
        if (!drawer) return;
        e.preventDefault();
        openCartDrawer();
      });
    });
    $$("[data-cart-close]").forEach(function (btn) {
      btn.addEventListener("click", closeCartDrawer);
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") closeCartDrawer();
    });

    $$("[data-add-to-cart]").forEach(function (btn) {
      if (btn.dataset.addBound) return;
      btn.dataset.addBound = "1";
      btn.addEventListener("click", function () {
        var variantId = btn.getAttribute("data-variant-id");
        if (!variantId) return;
        var label = $("span", btn);
        var original = label ? label.textContent : "";
        if (label) label.textContent = "Agregando…";
        cartAdd(variantId, 1).then(function () {
          if (label) label.textContent = original;
          openCartDrawer();
        });
      });
    });

    bindCartLineEvents();

    $$("[data-cart-note]").forEach(function (textarea) {
      var timer = null;
      textarea.addEventListener("input", function () {
        clearTimeout(timer);
        timer = setTimeout(function () { cartUpdateNote(textarea.value); }, 600);
      });
    });
  }

  /* ---------------- Product gallery thumbs ---------------- */
  function initProductGallery() {
    $$("[data-thumb]").forEach(function (thumb) {
      thumb.addEventListener("click", function () {
        var main = $("[data-product-main-image]");
        var full = thumb.getAttribute("data-full");
        if (main && full) main.src = full;
        $$("[data-thumb]").forEach(function (t) { t.classList.remove("is-active"); });
        thumb.classList.add("is-active");
      });
    });
  }

  /* ---------------- Contact / newsletter forms visual feedback ---------------- */
  function initFormFeedback() {
    $$(".contact-form").forEach(function (form) {
      form.addEventListener("submit", function () {
        var btn = $(".form-submit", form);
        if (!btn) return;
        var label = $(".submit-label", btn) || btn;
        label.textContent = "Enviando…";
      });
    });
  }

  /* ---------------- Boot ---------------- */
  function boot() {
    safe(initSplash, "initSplash");
    safe(initNav, "initNav");
    safe(initSmoothScroll, "initSmoothScroll");
    safe(initReveals, "initReveals");
    safe(initHeroMesh, "initHeroMesh");
    safe(initTilt, "initTilt");
    safe(initMagnetic, "initMagnetic");
    safe(initCountUp, "initCountUp");
    safe(initProductOptions, "initProductOptions");
    safe(initCardVariantPickers, "initCardVariantPickers");
    safe(initBeerToggles, "initBeerToggles");
    safe(initProductGallery, "initProductGallery");
    safe(initCart, "initCart");
    safe(initFormFeedback, "initFormFeedback");

    document.documentElement.classList.add("is-ready");
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
